const divider = 10;
const autoResize = function () {
    $('select[data-select-width="auto"]')
        .off('change')
        .on('change', function () {
            const text = $(this).find('option:selected').text();
            const spacerText = 'n'.repeat(Math.round(text.length/divider) - 0);
            const $aux = $('<select/>').append($('<option/>').text(text + spacerText));
            $(this).after($aux);
            $(this).width($aux.width());
            $aux.remove();
        })
        .trigger('change');
};

export {
    autoResize,
}
